import TextMoney from './TextMoney'

export default TextMoney
